// extracted by mini-css-extract-plugin
export default {"btn":"editmodal_btn__9Ub1Y","container":"editmodal_container__nZcf7"};